












import CategoryCheckbox from "@/components/CategoryCheckbox.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import categories from "../constants/categories";

@Component({
  components: {
    CategoryCheckbox
  }
})
export default class CategoryCheckboxList extends Vue {
  private selectedItems: string[] = [];

  private categories: { id: string; name: string }[] = categories;

  @Prop() private categoryIds!: string[];

  created() {
    this.selectedItems = this.categoryIds;
  }

  @Watch("selectedItems")
  nameChanged(items: string[]) {
    this.$emit("change", items);
  }
}
